<div class="status-bar jj-no-select" role="status" aria-live="polite">
  <div class="left">
    @if (fileIdentity(); as file) {
      <span
        class="stat stat-identity stat-identity--file"
        aria-label="Bound local file name"
        i18n-aria-label="@@status.filename.aria"
        title="Editing local file"
        i18n-title="@@status.filename.title"
      >
        <jj-icon name="save" [size]="14"></jj-icon>
        <span class="value">{{ file.filename }}</span>
      </span>
    } @else if (blobIdentity(); as blob) {
      <span
        class="stat stat-identity stat-identity--blob"
        aria-label="Loaded blob identifier"
        i18n-aria-label="@@status.blobSlug.aria"
        title="Editing saved blob"
        i18n-title="@@status.blobSlug.title"
      >
        <jj-icon name="link" [size]="14"></jj-icon>
        <span class="value">blob: {{ blob.slug }}</span>
      </span>
    }
    <span
      class="stat stat-chars"
      aria-label="Meaningful characters (whitespace and comments excluded)"
      i18n-aria-label="@@status.chars.aria"
      title="Meaningful characters (no whitespace or comments)"
      i18n-title="@@status.chars.title"
    >
      <span class="label" i18n="@@status.chars.label">Chars</span>
      <span class="value">{{ meaningfulChars() }}</span>
    </span>
    <span class="stat stat-lines" aria-label="Lines" i18n-aria-label="@@status.lines.aria">
      <span class="label" i18n="@@status.lines.label">Lines</span>
      <span class="value">{{ textStats().lines }}</span>
    </span>
    <span
      class="stat stat-bytes"
      aria-label="Size in UTF-8 bytes"
      i18n-aria-label="@@status.bytes.aria"
      title="Bytes if the document was downloaded as-is (UTF-8)"
      i18n-title="@@status.bytes.title"
    >
      <span class="label" i18n="@@status.bytes.label">Size</span>
      <span class="value">{{ bytesLabel() }}</span>
    </span>
    <span
      class="stat stat-cursor"
      aria-label="Cursor position"
      i18n-aria-label="@@status.cursor.aria"
    >
      <span class="label" i18n="@@status.cursor.label">Ln</span>
      <span class="value">{{ cursorLabel().line }}</span>
      <span class="label" i18n="@@status.col.label">Col</span>
      <span class="value">{{ cursorLabel().col }}</span>
    </span>
  </div>

  <div class="right">
    <span
      class="stat stat-nodes"
      aria-label="Total nodes"
      i18n-aria-label="@@status.nodes.aria"
      title="Total values in the tree, including objects, arrays, and primitives."
      i18n-title="@@status.nodes.title"
    >
      <span class="label" i18n="@@status.nodes.label">Total Nodes</span>
      <span class="value">{{ treeStats()?.nodes ?? placeholder }}</span>
    </span>
    <span
      class="stat stat-depth"
      aria-label="Maximum depth"
      i18n-aria-label="@@status.depth.aria"
      title="Maximum nesting depth. The root counts as depth 0; a direct child is depth 1."
      i18n-title="@@status.depth.title"
    >
      <span class="label" i18n="@@status.depth.label">Max Depth</span>
      <span class="value">{{ treeStats()?.depth ?? placeholder }}</span>
    </span>
    <span
      class="stat stat-obj"
      aria-label="Object count"
      i18n-aria-label="@@status.objects.aria"
      title="Number of object nodes in the tree."
      i18n-title="@@status.objects.title"
    >
      <span class="label" i18n="@@status.objects.label">Objects</span>
      <span class="value">{{ treeStats()?.objects ?? placeholder }}</span>
    </span>
    <span
      class="stat stat-arr"
      aria-label="Array count"
      i18n-aria-label="@@status.arrays.aria"
      title="Number of array nodes in the tree."
      i18n-title="@@status.arrays.title"
    >
      <span class="label" i18n="@@status.arrays.label">Arrays</span>
      <span class="value">{{ treeStats()?.arrays ?? placeholder }}</span>
    </span>
    @if (showComments()) {
      <span
        class="stat stat-comments"
        aria-label="Comment count"
        i18n-aria-label="@@status.comments.aria"
        title="Number of JSONC comments preserved during parsing."
        i18n-title="@@status.comments.title"
      >
        <span class="label" i18n="@@status.comments.label">Comments</span>
        <span class="value">{{ commentCount() }}</span>
      </span>
    }
    <span class="stat stat-mode" [class.mode-jsonc]="mode() === 'jsonc'">
      <span class="value mode">{{ modeLabel() }}</span>
    </span>
    <span class="stat stat-build" aria-live="off">
      @if (hasCommitLink) {
        <a
          class="build-link value"
          [href]="commitUrl"
          target="_blank"
          rel="noopener"
          [title]="buildTitle"
          [attr.aria-label]="commitAriaLabel"
          >v{{ buildVersion }} - {{ shortSha }}</a
        >
        <button
          type="button"
          class="build-copy"
          (click)="copySha()"
          aria-label="Copy commit SHA"
          i18n-aria-label="@@status.build.copy.aria"
        >
          <jj-icon name="copy" [size]="14"></jj-icon>
        </button>
      } @else {
        <span class="value sha" [title]="buildTitle">v{{ buildVersion }} - {{ shortSha }}</span>
      }
    </span>
  </div>
</div>
